/**
 * THIS FILE WILL WORK AS THE START UP FILE FOR THE APPLICATION
 * THIS WILL CONTAIN THE HEADER AND FOOTER AND COMMON ROUTE IMPORT
 */
import React from 'react';
import Header from 'HELPDESK/Header/Header';
import RoutesSetup from 'HELPDESK/Routes/Routes';
import Footer from 'HELPDESK/Footer/Footer';
import config from 'config'
import { ToastContainer } from "react-toastify";
import { Route } from 'react-router-dom';
import RightSidebar from 'HELPDESK/CommonResources/RightSideBar/RightSideBar';

class App extends React.Component{
  render() {
    if (config.instructorInfo == undefined || config.instructorInfo == '') {
      return (
        <div className="App">
        </div>
      );
    }
    else {
      return (
        <div className="App" style={{marginRight: '2.5%', overflowY: 'scroll',scrollbarWidth: 'none',msOverflowStyle: 'none'}}>
          <Header />
          <div id ="routeSetup"><RoutesSetup /></div>
          <RightSidebar />
          <Footer />
          <ToastContainer theme="light" />
        </div>
      );
    }
  }
  
}

export default App;
